// extracted by mini-css-extract-plugin
export default {"ratingList":"Reports_ratingList__I7VJ6","list":"Reports_list__98C47","empty":"Reports_empty__dZPwu"};